// Dependecies
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Moment from 'react-moment';
import moment from 'moment';

// Component
import Template from '../../components/Template';
import Successfully from '../../components/Successfully';
import Spinner from '../../components/Spinner';
import PopUp from '../../components/Modal';
import RenderTooltip from '../../components/RenderTooltip';

// Hooks
import useStatusService from '../../hooks/useStatusService';
import useGetService from '../../hooks/useGetService';
import useMaintenaceCompany from '../../hooks/useMaintenaceCompany';

// Images
import errorAlert from '../../../sass/images/alert/icon-error-alert.svg';
import img from '../../../sass/images/icons/right-check.svg';
import alertIcon from '../../../sass/images/icons/modal-alert.svg';
import eye from '../../../sass/images/ver-ocultar.svg';

function InfoService(props) {
  const { t } = props;
  const { token } = useParams();
  const { newMaintenances } = useStatusService();
  const { newMaintenancesCompany } = useMaintenaceCompany();
  const {
    reload,
    messageError,
    successfully,
    setSuccessfully,
    dataService,
    dataGarage,
    closeModal,
    openModalCancel,
    serviceCancelSucces,
    serviceAccept,
    serviceCancel,
    confirmationServiceCancel,
    menuToken,
    messagePermission,
    typeService,
    driver,
  } = useGetService(token, `${t('routers:MaintenanceSchedule')}`);
  const hourChange = (time) => moment(time, 'hh:mm a');

  return (
    <Template
      type={menuToken}
      newMaintenances={menuToken === 3 ? newMaintenances : newMaintenancesCompany}
      classNameContainer="maintenance"
      className="container_menu maintenance"
    >
      <>
        {openModalCancel ? (
          <PopUp
            open={openModalCancel}
            close={closeModal}
            icon={alertIcon}
            title={t('infoService:title-open-modal-cancel')}
            back={t('infoService:no-cancel')}
            go={t('infoService:yes-cancel')}
            accept={confirmationServiceCancel}
            modalDesign
            btnAccept
            btnClose
            classNameContent="modal-confirm"
            classNameBtn="btn_modal pink"
          />
        ) : (
          ''
        )}
        {!reload ? (
          <>
            {successfully ? (
              <Successfully
                img={img}
                t={t}
                setAlert={setSuccessfully}
                txt1={`${
                  !serviceCancelSucces
                    ? t('infoService:txt-successfully-info')
                    : t('infoService:txt-cacel-info')
                }`}
                txt2={t('infoService:txt-2-successfully-info')}
                txt3={`${
                  !serviceCancelSucces
                    ? t('infoService:txt-3-successfully-info')
                    : t('infoService:txt-3-cacel-info')
                }`}
                src={t('routers:MaintenanceSchedule')}
              />
            ) : (
              <Spinner text={t('alert:reload')}> </Spinner>
            )}
          </>
        ) : (
          <>
            {messagePermission ? (
              <div className="content_dynamic history">
                <Row className="content_history">
                  <div className="header-content">
                    <div className="info-tittle">
                      <h1 className="title-maintenances">{t('infoService:title-info')}</h1>
                    </div>
                  </div>
                  <div className="content-service_all">
                    <p>{t('infoService:not-permission')}</p>
                  </div>
                </Row>
              </div>
            ) : (
              <>
                <div className="content_dynamic history">
                  <Row className="content_history service_all">
                    <div className="header-content">
                      <div className="info-tittle">
                        <h1 className="title-maintenances">{t('infoService:title-info')}</h1>
                      </div>
                    </div>
                    <Accordion className="col-12">
                      <Card key={1} className="main-card">
                        <div className="borde-status status-1" />
                        <Card.Header className="card-maintenances head-show workshop-card info-service">
                          <Row>
                            <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                              <p className="title-2">{t('date-hour-request')}</p>
                              <p className="txt">
                                <Moment format="DD/MM/YYYY hh:mm a">
                                  {dataService.created_at}
                                </Moment>{' '}
                              </p>
                            </Col>
                            <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                              <p className="title-2">{t('date-hour-service')}</p>
                              <p className="txt">
                                <Moment format="DD/MM/YYYY">{dataService.date_service}</Moment>{' '}
                                <Moment
                                  date={hourChange(dataService.service_hours)}
                                  format="hh:mm a"
                                />
                              </p>
                            </Col>
                            <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                              <div className="arrow-card">
                                <p className="title-2">{t('type-service')}</p>
                                <p className="txt">
                                  {typeService.split(',')[0]}
                                  {typeService.split(',').length > 1 ? (
                                    <OverlayTrigger
                                      placement="top"
                                      className="tooltip-info vehicle"
                                      id="vehicle"
                                      delay={{ show: 50, hide: 500 }}
                                      overlay={(componentProps) =>
                                        RenderTooltip({
                                          ...componentProps,
                                          items: typeService.split(','),
                                          id: 'tooltip-type-services',
                                          classtxt: 'tooltip-txt-info ',
                                        })
                                      }
                                    >
                                      <img
                                        className="info-maintenance-company"
                                        src={eye}
                                        alt={t('alt:tooltip')}
                                      />
                                    </OverlayTrigger>
                                  ) : (
                                    ''
                                  )}
                                </p>
                              </div>
                            </Col>
                            <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                              <p className="txt">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-accept"
                                  onClick={() => {
                                    serviceAccept();
                                  }}
                                >
                                  {t('infoService:accept-info')}
                                </button>
                              </p>
                            </Col>
                            <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                              <p className="txt">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-cancel"
                                  onClick={() => {
                                    serviceCancel();
                                  }}
                                >
                                  {t('infoService:cancel-info')}
                                </button>
                              </p>
                            </Col>
                          </Row>
                        </Card.Header>

                        <Accordion.Collapse className="show" eventKey={1}>
                          <Card.Body className="description-card info-service">
                            <Row>
                              <Col xs={12} md={12} className="col-collapse">
                                <h6 className="bold">{t('observations')}</h6>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12} md={3} className="col-collapse">
                                <p className="second title-2">{t('name')}</p>
                                <p className="txt">{driver}</p>
                              </Col>
                              <Col xs={6} md={3} className="col-collapse">
                                <p className="second title-2">{t('license-plate')}</p>
                                <p className="txt">{dataService.licenseplate}</p>
                              </Col>
                              <Col xs={6} md={3} className="col-collapse">
                                <p className="second title-2">{t('brand')}</p>
                                <p className="txt"> {dataService.brand}</p>
                              </Col>
                              <Col xs={6} md={3} className="col-collapse">
                                <p className="second title-2">{t('model')}</p>
                                <p className="txt">{dataService.model}</p>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6} md={3} className="col-collapse">
                                <p className="second title-2">{t('garage')}</p>
                                <p className="txt"> {dataGarage.address}</p>
                              </Col>
                              {dataGarage.garage_car === 1 ? (
                                <Col xs={6} md={6} className="col-collapse">
                                  <p className="second title-2">{t('address-service')}</p>
                                  <p className="txt">{dataService.address_service}</p>
                                </Col>
                              ) : (
                                ''
                              )}
                            </Row>
                            <Row>
                              <Col xs={12} md={12} className="col-collapse">
                                <p className="second title-2">{t('description')}</p>
                                <p className="txt observations-mechanics">
                                  {dataService.description}
                                </p>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  </Row>
                </div>
              </>
            )}
          </>
        )}
        {messageError && (
          <Alert variant="danger" className="alert-response">
            <img src={errorAlert} alt={t('alt:errorAlert')} />
            <p>{t('alert:error')}</p>
          </Alert>
        )}
      </>
    </Template>
  );
}
InfoService.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['maintenance', 'infoService', 'alert', 'routers', 'alt'])(
  InfoService
);
